import { useField } from 'formik';
import { FC } from 'react';

import Form from '@controls/Form';

import Switcher from '@components/controls/Switcher';
import Accordion from '@components/uiKit/Accordion';

import { filterTitleStyles } from '../../../../../../styles';
import { getFieldName, isBooleanFilter } from '../../../../../../utils';
import FilterCheckboxes from './FilterCheckboxes';
import { accordionButtonStyles, booleanFilterContainerStyles } from './styles';
import { BooleanFilterToggleProps, DesktopFilterItemProps } from './types';

const BooleanFilterToggle: FC<BooleanFilterToggleProps> = ({ fieldName, trueValueCode, filterFieldName }) => {
    const [field, _, helpers] = useField<string[]>(fieldName);

    return (
        <div css={booleanFilterContainerStyles}>
            <span
                css={{
                    ...filterTitleStyles,
                    margin: 0,
                }}
            >
                {filterFieldName}
            </span>
            <div css={{ width: '48px', flexShrink: 0 }}>
                <Switcher
                    color="secondary"
                    name={fieldName}
                    value={trueValueCode}
                    field={{
                        ...field,
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                            const newValue = e.target.checked ? [trueValueCode] : [];
                            helpers?.setValue(newValue);
                        },
                    }}
                />
            </div>
        </div>
    );
};

const DesktopFilterItem: FC<DesktopFilterItemProps> = ({
    filterField,
    fieldPrefix,
    formKey,
    expandedFilters,
    onToggle,
    onFilterChange,
}) => {
    const filterItems = filterField.values || [];
    const isBoolean = isBooleanFilter(filterItems);
    const trueValueItem = isBoolean
        ? filterItems.find(item => {
              return 'value' in item && item.value === 'true';
          })
        : null;

    if (isBoolean && trueValueItem) {
        const fieldName = getFieldName(String(filterField.code), fieldPrefix);
        const trueValueCode = String(trueValueItem.code);

        return (
            <Form.Field name={fieldName}>
                <BooleanFilterToggle
                    fieldName={fieldName}
                    trueValueCode={trueValueCode}
                    filterFieldName={filterField.name}
                />
            </Form.Field>
        );
    }

    const filterCode = String(filterField.code);
    const isExpanded = expandedFilters[filterCode] || false;
    const displayedItems = isExpanded ? filterItems : filterItems.slice(0, 8);

    return (
        <Accordion.Item uuid={`popup-${filterField.code}-${formKey}`}>
            <Accordion.Heading>
                <Accordion.Button css={accordionButtonStyles}>{filterField.name}</Accordion.Button>
            </Accordion.Heading>

            <Accordion.Panel>
                <Form.Field name={fieldPrefix ? `${fieldPrefix}_${filterField.code}` : String(filterField.code)}>
                    <FilterCheckboxes
                        filterField={filterField}
                        fieldPrefix={fieldPrefix}
                        formKey={formKey}
                        filterCode={filterCode}
                        displayedItems={displayedItems}
                        filterItems={filterItems}
                        isExpanded={isExpanded}
                        onToggle={onToggle}
                        onFilterChange={onFilterChange}
                    />
                </Form.Field>
            </Accordion.Panel>
        </Accordion.Item>
    );
};

export default DesktopFilterItem;
